import "./BlogDetail.scss";
import { useState, useEffect } from "react";
import PageLayout from "../../layouts/pagelayout/PageLayout";
import CaseStudy from "../home/casestudy/CaseStudy";
import WOW from "wow.js";
import LoaderCard from "../../components/loaderCard/LoaderCard";

import axios from "axios";
import { baseUrl, blogDetail } from "../../utils/apiData";
import { useParams } from "react-router-dom";

const BlogDetail = () => {
  const formatDate = (isoString) => {
    var monthList = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(isoString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = monthList[(date.getMonth() + 1).toString()];
    const year = date.getFullYear().toString().slice(-2);

    return `${day} ${month} ${year}`;
  };

  const [num, setNum] = useState(0);
  const [blog, setBlog] = useState({});

  const [loader, setLoder] = useState(false);
  const { slug } = useParams();

  // Blog Detail APi
  const getBlogDetailApi = async () => {
    setLoder(true);
    try {
      const res = await axios.post(`${baseUrl}/${blogDetail}`, { slug });
      if (res?.data?.success) {
        setBlog(res?.data?.data);
        setLoder(false);
      }
    } catch (error) {
      setLoder(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getBlogDetailApi();
    const wow = new WOW();
    wow.init();
  }, []);

  return (
    <PageLayout>
      {loader ? (
        <LoaderCard />
      ) : (
        <section className="blog_detail">
          <div className="content_wrap p_top p_bottom">
            {/* For Mobile */}
            <div className="blog_info mobile">
              <div className="tag_date wow fadeInUp" data-wow-delay="0.1s">
                <p className="t-12">
                  <b>{blog?.author || "-"}</b>
                </p>
                <span></span>
                <p className="t-12">
                  <b>{formatDate(blog?.createdAt)}</b>
                </p>
              </div>
              <h2 className="wow fadeInUp">{blog?.name || "-"}</h2>
              <p className="t-16 wow fadeInUp" data-wow-delay="0.2s">
                {blog?.subtitle || "-"}
              </p>
            </div>
            {/* For Desktop */}
            <div className="bi_grid">
              <div className="left">
                <div className="blog_info tab">
                  <div className="tag_date wow fadeInUp">
                    <p className="t-12">{blog?.author || "-"}</p>
                    <span></span>
                    <p className="t-12">{formatDate(blog?.createdAt)}</p>
                  </div>
                  <h2 className="wow fadeInUp">{blog?.name || "-"}</h2>
                  <p className="wow fadeInUp t-16">{blog?.subtitle || "-"}</p>
                </div>
              </div>
              <div className="right">
                <div className="img_wrap">
                  <img src={`${baseUrl}/${blog?.image}`} alt="blog" />
                </div>
              </div>
            </div>

            {/* Content */}

            <div className="content">
              <div dangerouslySetInnerHTML={{ __html: blog?.content }} />
            </div>
          </div>
        </section>
      )}


    </PageLayout>
  );
};

export default BlogDetail;
